import {HttpClient, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {CurrentState} from "../../../../pastureProFECommon/projects/common-lib/src/lib/store/current-state";
import {CommonState} from "../../../../pastureProFECommon/projects/common-lib/src/lib/store/reducer";

@Injectable({ providedIn: 'root' })
export class FileDownloadService {
  constructor(
    private http: HttpClient,
    protected currentState: CurrentState<CommonState>
  ) {}

  downloadFile(url: string, filename: string): void {
    console.log('file download started');
    const token = this.currentState.snapshot.user.token;
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`
    });

    this.http.get(url, { headers, responseType: 'blob' }).subscribe(blob => {
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();

      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    });
  }
}
